import { Injectable, Injector } from "@angular/core";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { AbstractRender } from "src/app/abstract/render.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";
import { Logger } from "src/app/core/logger";
import { WidgetsRowModel } from "src/app/models/widgets/widgets-row.model";
import { RenderService } from "./render.service";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";

@Injectable({
  providedIn: 'root'
})
export class RenderRowService extends AbstractRender {
  constructor(
    private injector: Injector,
    private logger: Logger
  ) {
    super();
  }

  /**
   * Recursive render method
   *
   * @param widget A layout node
   * @param config Formly field config array
   * @param widgetRoot Root of the layout
   * @param formlyRoot Root of the FormlyFieldConfig
   * @param isInsideQuestion True if we are rendering a subtree inside a question
   * @param isRecursive True if we want to traverse the tree to the bottom. False if we just want to render a node.
   */
  render(widget: WidgetsAbstract,
    config: FormlyFieldConfig[],
    widgetRoot: WidgetsAbstract,
    formlyRoot: FormlyFieldConfig,
    isInsideQuestion: boolean,
    isRecursive: boolean,
  ) {

    let field: FormlyFieldConfig;

    try {
      if (widget instanceof WidgetsRowModel) {
        const currentWidget = widget as WidgetsRowModel;

        // const customFormModel: WidgetsFormModel = currentWidget.widgetTree as WidgetsFormModel;
        isInsideQuestion = false;
        if (isInsideQuestion) {
          field = {
            fieldGroup: []
          };
        } else {
          field = {
            type: 'flex-layout',
            props: {
              // fxLayoutGap: '20px grid',
              fxLayoutGap: '0px grid',
              description: 'ROW',
            },
            fieldGroup: []
          };
          // , validators: { validation: [] }
        }

        // Mix created input with widget template
        if (currentWidget.template) {
          const modelTemplate = JSON.parse(currentWidget.template);
          field = Object.assign({}, field, modelTemplate);
        }

        config.push(field);

        // FIXME: formlyRoot overwritten with ROW. Is this right?
        if (isRecursive) {
          const renderService = this.injector.get(RenderService);
          currentWidget.children?.forEach((childWidget, index) => {
            if (childWidget instanceof WidgetsColumnModel) {
              childWidget.ordinal = index;
              childWidget.columnNumber = currentWidget.children.length;
            }

            // eslint-disable-next-line
            renderService.render(childWidget, field.fieldGroup!, widgetRoot, field, isInsideQuestion, isRecursive);
            // field.validators.validation
          });
        }

      }
    } catch (error) {
      this.logger.log(error);
    }
  }
}
